<template>
    <v-list-item :key="order.id" class="px-5" :to="{name: 'order', params: {id: order.id}}" v-ripple="phoneOnly ? {class: 'ripple--color'} : false">
        <v-list-item-avatar class="me-4 me-lg-6 ">
            <v-icon :color="order.status === 'completed' ? 'success' : 'strong-text'">mdi-cart-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title class="strong-text--text">طلب رقم #{{order.local_serial}}</v-list-item-title>
            <v-list-item-subtitle class="details-text d-flex align-center">
                <div class="me-2">
                    <v-chip label small dark outlined :color="orderStatusChip.color" style="height: 20px;" class="pe-2">
                        <v-icon left size="16" class="me-2">{{orderStatusChip.icon}}</v-icon>
                        {{orderStatusChip.text}}
                    </v-chip>                    
                </div>
                <div>
                    {{timeFormat(order.created_at, true)}}
                </div>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
            <div class="d-flex align-center">
                <div>
                    <span style="font-size: 0.95rem">{{moneyFormat(order.total)}}</span>
                    <small class="ms-1 muted--text small-text">د.ع</small>
                </div>
            </div>
        </v-list-item-icon>
    </v-list-item>    
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        order: {},
    },
    data(){
        return {
            orderStatusItems: [
                {text: 'انتظار القبول', value: 'review', color: 'blue-grey', icon: 'mdi-file-document-outline'},
                {text: 'جاري التجهيز', value: 'in_progress', color: 'primary', icon: 'mdi-package-variant'},
                {text: 'جاري التوصيل', value: 'in_delivery', color: 'orange darken-2', icon: 'mdi-truck-fast-outline'},
                {text: 'تم التوصيل', value: 'delivered', color: 'indigo', icon: 'mdi-truck-check-outline'},
                {text: 'طلب مكتمل', value: 'completed', color: 'success', icon: 'mdi-check-circle-outline'},
                {text: 'طلب ملغي', value: 'canceled', color: 'red', icon: 'mdi-close-circle-outline'},
                {text: 'مرتجع', value: 'returned', color: 'deep-orange', icon: 'mdi-login'},
            ],  
        };
    },
    watch :{
        
    },
    computed: {
        ...GlobalComputed,
        orderStatusChip(){
            const status = this.order.status;
            return this.getStatusChip(status);
        },
    },
    methods: {
        ...GlobalMethods,
        getStatusChip(status){
            const chip = this.orderStatusItems.find(item=>item.value === status);
            if (chip){
                return chip;
            }else{
                return {text: status, color: 'primary', icon: 'mdi-flag-outline'}
            }
        },
        sync(payload){
            this.$emit('sync', payload);
        }
    }
}
</script>
